<app-error-detail-table-record-template [error]="error" (errorTypeUpdated)="updateErrorType($event)"
                           (errorSolved)="solveError()" [loadingErrorData]="isLoading" [isSolvingError]="isSolving">
    <app-error-detail-rule ruleNameKey="components.errorDetails.errorCardDetails.ruleName.description"
                           [content]="error!.description"/>
    <app-error-detail-rule ruleNameKey="components.errorDetails.errorCardDetails.ruleName.content"
                           [content]="error!.content"/>
</app-error-detail-table-record-template>
